/**
 * @file Текущий язык интерфейса и его переключение.
 *
 * Начальное значение выбирается из localStorage и настроек браузера.
 * Context обновляет подписанные компоненты без повторного входа или передачи.
 */
import { useEffect, useState } from 'react'
import type { ReactNode } from 'react'

import { LocaleContext } from './LocaleContext'
import { type Locale, readLocale, saveLocale } from './locale'

function browserStorage() {
    try {
        return window.localStorage
    } catch {
        return undefined
    }
}

export function LocaleProvider({ children }: { children: ReactNode }) {
    const [locale, setLocale] = useState<Locale>(() =>
        readLocale(browserStorage(), navigator.languages),
    )

    useEffect(() => {
        document.documentElement.lang = locale
    }, [locale])

    function changeLocale(value: Locale) {
        saveLocale(browserStorage(), value)
        setLocale(value)
    }

    return (
        <LocaleContext.Provider value={{ locale, changeLocale }}>
            {children}
        </LocaleContext.Provider>
    )
}
